<template>
	<div class="user_dash_panel claim_place" :style="'--accent:' + accent">

		<p>This booking is for <b>{{ number_of_participants }} people</b></p>
		<template v-if="participants.length > 0">
			<p v-if="number_of_participants - spaces == 1">There is <b>1 person</b> already attending</p>
			<p v-else>There are <b>{{ number_of_participants - spaces }} people</b> already attending</p>
			<ul>
				<li v-for="(participant, key) in participants">
					<span>{{ participant }}
						<span v-if="key==0">- Organiser</span>
					</span>
				</li>
			</ul>
		</template>
		<div class="claim_bar">
			<button v-if="show_button && spaces >= 1" v-on:click="claimPlace()" class="button small accent solid">
				<span class="fa-stack fa-1x">
					<i class="fas fa-user-check fa-stack-2x"></i>
				</span>
				Claim your place
			</button>
			<p v-if="spaces == 0"><i class="fas fa-info-circle"></i> All places have been filled. Please contact {{ lead_booker_name }} if you'd like to attend.</p>
			<p v-if="spaces == 1"><i class="fas fa-info-circle"></i> There is {{ spaces }} place remaining.</p>
			<p v-if="spaces >= 2"><i class="fas fa-info-circle"></i> There are {{ spaces }} places remaining.</p>
		</div>

	</div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
export default {

	props: [
		'uuid',
		'accent',
		'number_of_participants',
		'available_spaces',
		'lead_booker_name',
		'logged_in',
		'claimed',
	],

	data: () => {
		return {
			participants: {},
			spaces: 0,
			show_button: true
		}
	},

	computed: {
	},

	watch: {
	},

	created() {
	},

	mounted() {
		this.getParticipantList();
		this.updateAvailableSpaces(this.available_spaces);
		if (this.claimed) { this.hideClaimButton(); }
	},

	methods: {

		...mapActions(['addAlert']),

		getParticipantList: function(){
			axios.post('/ajax/getParticipantList', {
				uuid: this.uuid
			})
			.then(response => {
				this.participants = response.data
			})
			.catch(error => {
				console.log(error);
			});
		},

		updateAvailableSpaces: function (spaces) {
			this.spaces = spaces;
		},

		hideClaimButton: function () {
			this.show_button = false;
		},

		claimPlace: function(){
			if (this.logged_in) {
				// attach straight away
				this.show_button = false;
				this.$root.$refs.claimform.skipForm()
			} else {
				// open popup
				this.toggleClaimForm();
			}
		},

		toggleClaimForm: function(){
			this.$root.$refs.claimform.toggleClaimForm();
		},

		alert: function(message, type, important = false) {
			this.addAlert({
				alertClass: 'alert-' + type, 
				alertMessage: message, 
				alertImportant: important,
			});
		},
	}
};
</script>